import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Unified product data from Products.jsx
const products = [
  {
    category: 'Loans',
    items: [
      { id: 1, title: 'Biashara Loan' },
      { id: 2, title: 'Asset Financing' },
      { id: 3, title: 'Top-Up Loans' },
      { id: 14, title: 'Personal Loans' },
      { id: 15, title: 'LPO Financing' },
    ],
  },
  {
    category: 'Trade Finance',
    items: [
      { id: 5, title: 'Unsecured Bid Bonds' },
      { id: 6, title: 'Performance Bonds' },
      { id: 7, title: 'Advance Payment Guarantees' },
      { id: 8, title: 'Bank Guarantees' },
      { id: 16, title: 'Custom Bonds' },
      { id: 17, title: 'Retention Bonds' },
    ],
  },
  {
    category: 'Insurance Services',
    items: [
      { id: 9, title: 'Contractor’s All Risk (CAR)' },
      { id: 10, title: 'Work Injury Benefits Act (WIBA)' },
      { id: 11, title: 'Professional Indemnity' },
      { id: 12, title: 'Motor Insurance' },
      { id: 18, title: 'Medical Insurance' },
      { id: 19, title: 'Domestic Package' },
      { id: 20, title: 'Marine Insurance' },
      { id: 21, title: 'Travel Insurance' },
      { id: 22, title: "Golfer's Insurance" },
    ],
  },
];

function Footer() {
  const [showCookieConsent, setShowCookieConsent] = useState(true);

  useEffect(() => {
    if (localStorage.getItem('cookieConsent') === 'accepted') {
      setShowCookieConsent(false);
    }
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowCookieConsent(false);
  };

  const orbs = Array.from({ length: 6 }).map((_, i) => {
    const size = Math.random() * 25 + 15; // 15px–40px
    const directions = ['up', 'left', 'right', 'up-left', 'up-right'];
    const direction = directions[Math.floor(Math.random() * directions.length)];
    const delay = Math.random() * 5; // 0–5s
    const left = Math.random() * 100; // 0–100%
    const top = Math.random() * 100; // 0–100%
    const opacity = Math.random() * 0.2 + 0.2; // 0.2–0.4
    return { id: i, size, direction, delay, left, top, opacity };
  });

  return (
    <>
      <footer className="relative bg-primary-blue text-white overflow-hidden">
        <div className="orbs absolute inset-0 z-[-5]">
          {orbs.map(({ id, size, direction, delay, left, top, opacity }) => (
            <span
              key={id}
              className={`orb animate-orb-${direction}`}
              style={{
                width: `${size}px`,
                height: `${size}px`,
                left: `${left}%`,
                top: `${top}%`,
                animationDelay: `${delay}s`,
                opacity,
              }}
            ></span>
          ))}
        </div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-24 bg-primary-blue">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 mb-12 border-b border-gray-500/50 pb-12">
            {products.map((category, index) => (
              <div key={category.category} className={`animate-fade-up animate-fade-up-delay-${index}`}>
                <h3 className="text-lg font-inter font-bold mb-4 text-primary-green header-underline">
                  {category.category}
                </h3>
                <ul className="text-white text-xs sm:text-sm font-roboto font-normal space-y-2">
                  {category.items.map((item) => (
                    <li key={item.id}>
                      <Link
                        to={`/products?category=${encodeURIComponent(category.category)}&productId=${item.id}`}
                        className="relative inline-block draw-line"
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                        aria-label={`View ${item.title}`}
                      >
                        <span>{item.title}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div className="animate-fade-up animate-fade-up-delay-3">
              <h3 className="text-lg font-inter font-bold mb-4 text-primary-green header-underline">Quick Links</h3>
              <ul className="text-white text-xs sm:text-sm font-roboto font-normal space-y-2">
                {[
                  { title: 'Home', path: '/' },
                  { title: 'About Us', path: '/about-us' },
                  { title: 'Products', path: '/products' },
                  { title: 'Careers', path: '/careers' },
                  { title: 'Contact Us', path: '/contact-us' },
                  { title: 'Branches', path: '/branches' },
                ].map(({ title, path }) => (
                  <li key={title}>
                    <Link
                      to={path}
                      className="relative inline-block draw-line"
                      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                      aria-label={`Visit ${title} page`}
                    >
                      <span>{title}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center animate-slide-in-bottom">
            <div className="text-gray-300 text-xs font-inter font-normal">
              Regulated by the Central Bank of Kenya | © 2025 TGL Credit Limited. Developed By{' '}
              <a
                href="https://jecthub.com"
                target="_blank"
                rel="noopener noreferrer"
                className="font-roboto text-primary-red hover:text-primary-red-dark hover:underline underline-offset-4 transition"
              >
                JectHub
              </a>.
            </div>
            <div className="flex items-center justify-center space-x-4">
              {[
                { platform: 'facebook', url: 'https://facebook.com/tglcredit', label: 'Facebook' },
                { platform: 'x', url: 'https://x.com/tglcredit', label: 'X' },
                { platform: 'linkedin', url: 'https://linkedin.com/company/tglcredit', label: 'LinkedIn' },
                { platform: 'instagram', url: 'https://instagram.com/tglcredit', label: 'Instagram' },
              ].map(({ platform, url, label }) => (
                <a
                  key={platform}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white text-primary-blue rounded-full p-2 transition-all duration-300 hover:bg-primary-red hover:text-white hover:scale-110 hover:shadow-primary-red/30 focus:ring-2 focus:ring-primary-red focus:ring-offset-2"
                  aria-label={`Visit TGL Credit on ${label}`}
                >
                  {platform === 'facebook' && (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.99 3.66 9.13 8.44 9.88v-6.99h-2.54v-2.89h2.54v-2.2c0-2.51 1.49-3.89 3.78-3.89c1.09 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.86h2.78l-.45 2.89h-2.33v6.99c4.78-.75 8.44-4.89 8.44-9.88z" />
                    </svg>
                  )}
                  {platform === 'x' && (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                    </svg>
                  )}
                  {platform === 'linkedin' && (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                    </svg>
                  )}
                  {platform === 'instagram' && (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.326 3.608 1.301.975.975 1.24 2.242 1.301 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.326 2.633-1.301 3.608-.975.975-2.242 1.24-3.608 1.301-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.326-3.608-1.301-.975-.975-1.24-2.242-1.301-3.608-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.326-2.633 1.301-3.608.975.975 2.242 1.24 3.608 1.301 1.266.058 1.646.07 4.85.07s3.667-.014 4.947-.072c1.627-.073 3.043-.532 4.192-1.681 1.149-1.149 1.608-2.565 1.681-4.192.058-1.28.072-1.688.072-4.947s-.014-3.667-.072-4.947c-.073-1.627-.532-3.043-1.681-4.192-1.149-1.149-2.565-1.608-4.192-1.681-1.28-.058-1.688-.072-4.947-.072zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.162 6.162 6.162 6.162-2.759 6.162-6.162-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.441s.645 1.441 1.441 1.441 1.441-.645 1.441-1.441-.645-1.441-1.441-1.441z" />
                    </svg>
                  )}
                </a>
              ))}
            </div>
            <div className="text-gray-300 text-xs font-inter font-normal">
              <ul className="flex flex-wrap justify-center space-x-2">
                {[
                  { title: 'Social Media Disclaimer', path: '/social-media-disclaimer' },
                  { title: 'Terms & Condition', path: '/terms' },
                  { title: 'Cookie Policy', path: '/cookie-policy' },
                  { title: 'Customer Promise', path: '/customer-promise' },
                  { title: 'Data Privacy Statement', path: '/data-privacy' },
                ].map(({ title, path }) => (
                  <li key={title}>
                    <Link
                      to={path}
                      className="relative inline-block draw-line"
                      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                      aria-label={`View ${title}`}
                    >
                      <span>{title}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </footer>

      {/* Cookie Consent Window */}
      {showCookieConsent && (
        <div className="fixed bottom-4 left-4 bg-white/95 backdrop-blur-sm text-gray-800 p-4 rounded-lg shadow-xl max-w-xs z-50 animate-fade-in border border-gray-200/50">
          <div className="flex justify-between items-center mb-2">
            <h4 className="font-inter font-semibold text-xs">Cookie Consent</h4>
            <button
              onClick={handleAcceptCookies}
              className="text-gray-600 hover:text-gray-800 focus:ring-2 focus:ring-primary-red focus:ring-offset-2"
              aria-label="Close cookie consent"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <p className="font-inter text-[10px] mb-4">
            We use cookies to enhance your experience. By continuing, you accept our use of cookies.
          </p>
          <button
            onClick={handleAcceptCookies}
            className="bg-primary-red text-white font-roboto text-[10px] px-3 py-1 rounded-full hover:bg-primary-red-dark hover:scale-105 transition-all duration-300 w-full focus:ring-2 focus:ring-primary-red focus:ring-offset-2"
            aria-label="Accept cookies"
          >
            Accept
          </button>
        </div>
      )}

      {/* WhatsApp Chat Icon */}
      <a
        href="https://wa.me/+254705194362"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-primary-red text-white p-4 rounded-full shadow-lg hover:bg-primary-red-dark hover:scale-110 transition-all duration-300 z-50 animate-pulse-glow focus:ring-2 focus:ring-primary-red focus:ring-offset-2"
        aria-label="Contact TGL Credit on WhatsApp"
      >
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-5.46-4.45-9.91-9.91-9.91zm5.76 15.07c-.24.69-.94 1.05-1.55.71-.60-.34-3.53-1.74-4.09-1.93-.56-.19-.97-.27-1.37.29-.39.56-1.5 1.82-1.84 2.19-.34.37-.69.42-1.29.14-.60-.28-2.54-1.29-2.83-1.54-.29-.25-.73-.94-.73-1.62 0-.69.36-1.03.54-1.31.18-.28.42-.46.69-.78.28-.32.37-.60.56-.97.19-.37.09-.69-.05-1.03-.14-.34-1.22-2.94-1.36-3.28-.14-.34-.28-.6-.65-.6-.37 0-.74-.09-1.13-.09-.39 0-.74.14-1.03.42-.28.28-1.03 1.03-1.03 2.54 0 1.5 1.08 2.94 1.22 3.13.14.19 2.16 3.28 5.24 4.6.73.32 1.29.56 1.73.73.44.18.83.28 1.22.37.39.09.74.05 1.03-.05.28-.09.65-.42.83-.56.18-.14.32-.32.42-.56.09-.24.09-.51.05-.74-.05-.23-.14-.42-.23-.56z" />
        </svg>
      </a>

      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-20 right-4 bg-primary-blue text-white p-4 rounded-full shadow-lg hover:bg-primary-blue-dark hover:scale-110 transition-all duration-300 z-50 animate-pulse-glow focus:ring-2 focus:ring-primary-blue focus:ring-offset-2"
        aria-label="Scroll to top"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </button>

      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;500;700&family=Roboto:wght@300;500;700&display=swap');
          @keyframes fade-up {
            from { opacity: 0; transform: translateY(15px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-up {
            animation: fade-up 0.6s ease-out forwards;
          }
          .animate-fade-up-delay-0 {
            animation-delay: 0s;
          }
          .animate-fade-up-delay-1 {
            animation: fade-up 0.6s ease-out 0.3s forwards;
            opacity: 0;
          }
          .animate-fade-up-delay-2 {
            animation: fade-up 0.6s ease-out 0.5s forwards;
            opacity: 0;
          }
          .animate-fade-up-delay-3 {
            animation: fade-up 0.6s ease-out 0.65s forwards;
            opacity: 0;
          }
          @keyframes slide-in-bottom {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-slide-in-bottom {
            animation: slide-in-bottom 0.8s ease-out 0.9s forwards;
            opacity: 0;
          }
          @keyframes fade-in {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          .animate-fade-in {
            animation: fade-in 0.6s ease-out forwards;
          }
          @keyframes pulse-glow {
            0% { box-shadow: 0 0 5px rgba(47, 73, 140, 0.5); }
            50% { box-shadow: 0 0 10px rgba(47, 73, 140, 0.8); }
            100% { box-shadow: 0 0 5px rgba(47, 73, 140, 0.5); }
          }
          .animate-pulse-glow {
            animation: pulse-glow 2s ease-in-out infinite;
          }
          .orbs {
            pointer-events: none;
          }
          .orb {
            position: absolute;
            border-radius: 50%;
            background: radial-gradient(circle, rgba(132, 51, 69, 0.4), transparent);
            box-shadow: 0 0 10px rgba(132, 51, 69, 0.5);
            animation: ease-in-out infinite;
          }
          @keyframes orb-up {
            0% { transform: translateY(0); opacity: 0.6; }
            100% { transform: translateY(-100vh); opacity: 0; }
          }
          .animate-orb-up {
            animation-name: orb-up;
            animation-duration: 8s;
          }
          @keyframes orb-left {
            0% { transform: translateX(0); opacity: 0.6; }
            100% { transform: translateX(-100vw); opacity: 0; }
          }
          .animate-orb-left {
            animation-name: orb-left;
            animation-duration: 10s;
          }
          @keyframes orb-right {
            0% { transform: translateX(0); opacity: 0.6; }
            100% { transform: translateX(100vw); opacity: 0; }
          }
          .animate-orb-right {
            animation-name: orb-right;
            animation-duration: 10s;
          }
          @keyframes orb-up-left {
            0% { transform: translate(0, 0); opacity: 0.6; }
            100% { transform: translate(-50vw, -50vh); opacity: 0; }
          }
          .animate-orb-up-left {
            animation-name: orb-up-left;
            animation-duration: 9s;
          }
          @keyframes orb-up-right {
            0% { transform: translate(0, 0); opacity: 0.6; }
            100% { transform: translate(50vw, -50vh); opacity: 0; }
          }
          .animate-orb-up-right {
            animation-name: orb-up-right;
            animation-duration: 9s;
          }
          @media (prefers-reduced-motion: reduce) {
            .animate-fade-up, .animate-fade-up-delay-0, .animate-fade-up-delay-1, .animate-fade-up-delay-2, .animate-fade-up-delay-3, .animate-slide-in-bottom, .animate-fade-in, .animate-pulse-glow, .animate-orb-up, .animate-orb-left, .animate-orb-right, .animate-orb-up-left, .animate-orb-up-right, .hover\\:scale-110, .hover\\:scale-105, .hover\\:shadow-primary-red\\/30 {
              animation: none !important;
              transform: none !important;
              opacity: 1 !important;
              transition: none !important;
            }
          }
          .draw-line {
            position: relative;
          }
          .draw-line::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: var(--primary-red);
            transform: scaleX(0);
            transform-origin: left;
            transition: transform 0.3s ease;
          }
          .draw-line:hover::after {
            transform: scaleX(1);
          }
          .header-underline {
            position: relative;
            display: inline-block;
          }
          .header-underline::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: var(--primary-red);
          }
          :root {
            --primary-blue: #2F498C;
            --primary-blue-dark: #1e355f;
            --primary-red: #843345;
            --primary-red-dark: #672737;
            --primary-green: #00c449;
          }
          .bg-primary-blue {
            background-color: var(--primary-blue);
          }
          .bg-primary-blue-dark {
            background-color: var(--primary-blue-dark);
          }
          .bg-primary-red {
            background-color: var(--primary-red);
          }
          .bg-primary-red-dark {
            background-color: var(--primary-red-dark);
          }
          .text-primary-blue {
            color: var(--primary-blue);
          }
          .text-primary-red {
            color: var(--primary-red);
          }
          .text-primary-green {
            color: var(--primary-green);
          }
          .hover\\:bg-primary-blue:hover {
            background-color: var(--primary-blue);
          }
          .hover\\:bg-primary-blue-dark:hover {
            background-color: var(--primary-blue-dark);
          }
          .hover\\:bg-primary-red:hover {
            background-color: var(--primary-red);
          }
          .hover\\:bg-primary-red-dark:hover {
            background-color: var(--primary-red-dark);
          }
          .hover\\:text-primary-red-dark:hover {
            color: var(--primary-red-dark);
          }
          .hover\\:shadow-primary-red\\/30:hover {
            --tw-shadow-color: rgba(132, 51, 69, 0.3);
            --tw-shadow: var(--tw-shadow-colored);
          }
          .focus\\:ring-primary-blue:focus {
            --tw-ring-color: var(--primary-blue);
          }
          .focus\\:ring-primary-red:focus {
            --tw-ring-color: var(--primary-red);
          }
        `}
      </style>
    </>
  );
}

export default Footer;